export default function ReportSectionTitle({
  title,
  hideMarginTop,
  allBorders,
}) {
  return (
    <div
      className={`${!hideMarginTop ? "mt-2 " : ""}report_title_section ${
        allBorders ? "report_title_bottom_border" : ""
      }`}
    >
      <label style={{ fontSize: "14px", whiteSpace: "nowrap" }}>{title}</label>
    </div>
  );
}
